// extracted by mini-css-extract-plugin
module.exports = {"tanks-container":"Tanks_tanks-container__H47d1"};